import { Component, Input, ViewEncapsulation, OnChanges, SimpleChanges, OnInit } from '@angular/core';

export interface ITab {
    tabID: number;
    tabTitle: string;
    tabIcon: string;
    badgeText: string;
    badgeStatus: string;
    badgeDot: boolean;
    badgePosition: any;
}

@Component({
  selector: 'nbx-tabs',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.scss'],
  encapsulation: ViewEncapsulation.ShadowDom
})

export class TabsComponent implements OnInit, OnChanges{
  // defaulttabs = 2;
  @Input() orientation = "horizontal";
  @Input() linearMode = "Disable";
  // @Input() tabs = this.defaulttabs;
  @Input() titles: string ='Tab 1,Tab 2'
  @Input() icons: string = '';
  @Input() badges = [{'text': 'text on the badge', 'position': 'top left', 'status': 'success'}, {'text': 'text on the badge', 'position': 'top right', 'status': 'success'}]
  @Input() badgeDot = true;
  @Input() status = 'primary';
  numbers = [];
  length = this.numbers.length
  initialized = false;
  tabs = 2;
  // current = this.tabs;

  titleList = [];
  iconList = [];
  

  ngOnInit() {
    if (this.titles  !== '')
    {
      this.titleList = this.titles.split(',');
      this.iconList = this.icons.split(',');
      this.tabs = this.titleList.length;
    }

    this.createSteps(this.tabs)
    this.initialized = true;
  }

  ngOnChanges (changes: SimpleChanges) {
    for(const propName in changes)
    {
      if (changes.hasOwnProperty(propName) && this.initialized === true) {
        switch(propName) {
          case 'titles': {
            if (this.titles !== '') {
              this.titleList = this.titles.split(',');
              this.tabs = this.titleList.length;
              this.numbers = [];
              this.createSteps(this.tabs);
            }
            else {
              this.tabs = 2;
              this.numbers = [];
              this.createSteps(this.tabs);
            }
            
          }
          case 'icons': {
            if (this.icons !== '') {
              this.iconList = this.icons.split(',');
              this.tabs = this.titleList.length;
              this.numbers = [];
              this.createSteps(this.tabs);
            }
          }
        }
      }
    }
  }
  
  createSteps(num) {
    for (var i = 0; i < num; i++) {
      this.addStep(i+1);
    }
  }

  addStep(idVal) {
      var newTab = {
        tabID: 'tab_'+ idVal,
        tabTitle: this.getLabel(idVal-1),
        tabIcon: this.iconList[idVal-1] ? this.iconList[idVal-1] : ''
      }

      this.numbers.push(newTab);
      this.length = this.numbers.length;
  }

  getLabel(index) {

    var defaultTitle = 'Tab '+ (index + 1);

    if (this.titleList.length > 0)
    {
      if (this.titles[index] !==undefined && this.titleList[index] !== '' )
      {
        return this.titleList[index];
      }
    }
    return  defaultTitle;
  }

  removeStep() {
    
  }
}